import React, { useState, useEffect, useContext } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { Loading } from 'element-react';
import { UserContext } from '../App';
import {
  OrderBlock,
  OrderHead,
  OrderTop,
  OrderId,
  StatusPill,
  MetaGrid,
  MetaLabel,
  MetaValue,
  ProductGrid,
  EmptyMsg,
  PageContainer,
} from '../components/OrderStyles';
import OrderProduct from '../components/OrderProduct';
import { format } from 'date-fns';
import { convertCentsToDollar } from '../utils';

const ordersByUser = /* GraphQL */ `
  query OrdersByUser(
    $UserOrders: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByUser(
      UserOrders: $UserOrders
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        price
        shipped
        status
        createdAt
        shippingAddress {
          city
          address_line1
          address_state
          address_zip
        }
        products {
          items {
            id
            description
            price
            quantity
            instock
            file {
              key
            }
          }
        }
      }
      nextToken
    }
  }
`;

const OrderHistoryPage = () => {
  const { user } = useContext(UserContext);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchOrders();
    }
  }, [user]);

  const fetchOrders = async () => {
    try {
      const input = {
        UserOrders: user.attributes.sub,
        sortDirection: 'DESC',
      };
      const result = await API.graphql(graphqlOperation(ordersByUser, input));
      setOrders(result.data.ordersByUser.items);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching orders:', error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading fullscreen={true} />;
  }

  return (
    <PageContainer>
      <h1 className="market-title">Your Orders</h1>
      {orders.length > 0 ? (
        orders.map(order => (
          <OrderBlock key={order.id}>
            <OrderHead>
              <OrderTop>
                <OrderId>Order ID: <strong>{order.id}</strong></OrderId>
                <StatusPill $status={order.status}>{order.status}</StatusPill>
              </OrderTop>
              <MetaGrid>
                <div>
                  <MetaLabel>Date Placed</MetaLabel>
                  <MetaValue>{format(new Date(order.createdAt), 'MMMM d, yyyy')}</MetaValue>
                </div>
                <div>
                  <MetaLabel>Total</MetaLabel>
                  <MetaValue>${convertCentsToDollar(order.price)}</MetaValue>
                </div>
              </MetaGrid>
            </OrderHead>
            <ProductGrid>
              {order.products.items.map(product => (
                <OrderProduct key={product.id} product={product} order={order} isEdit={false} />
              ))}
            </ProductGrid>
          </OrderBlock>
        ))
      ) : (
        <EmptyMsg>You have no past orders.</EmptyMsg>
      )}
    </PageContainer>
  );
};

export default OrderHistoryPage;